// src/data/aplicativos/Livejoy.js
//import logoLivejoy from "../../assets/logoLivejoy3D.png";
import capturaLivejoy from "../../assets/livejoy.png";
import monitoriada from "../../assets/llamadaMonitoriadaLivejoy.png";
import privada from "../../assets/llamadaPrivadaLivejoy.png";
import lives from "../../assets/livesLivejoy.png";
import regalos1 from "../../assets/listaRegalosLivejoy1.jpg";
import regalos2 from "../../assets/listaRegalosLivejoy2.jpg";
import regalos3 from "../../assets/listaRegalosLivejoy3.jpg";
import regalos4 from "../../assets/listaRegalosLivejoy4.jpg";
import tareas from "../../assets/tareasLivejoy.jpg";
const Livejoy = {
  nombre: "Livejoy",
  alt: "Logo livejoy en 3D",
  logo: capturaLivejoy,
  descripcion: [
    "Una Aplicación de citas en la cual podrás generar ganancias por cada minuto que dures en una videollamada con los usuarios, cuenta también con lives donde podrás hacer transmisión en vivo con varios usuarios que podrán interactuar contigo en tiempo real.",
    "Tiene una meta mínima de 20.000 punto equivalentes a 26 dólares y la meta máxima te la pones tu, puedes generar mas de 500 dólares semanales si te lo propones."
  ],
  secciones: [
    {
      titulo: "Cómo generar ganancias",
      descripcion: "Tienes diferentes formas de obtener ganancias:",
      contenidoTipo: "textoEstructurado",
      contenido: [
        { tipo: "parrafo", texto: "**Video llamadas:** Existen dos tipos de video llamadas" },
        { tipo: "item", texto: "**Aleatoria:** Llamada en la cual los primeros 30 segundos son monitoreados, ganas 60 puntos por cada minuto que dure la llamada." },
        { tipo: "item", texto: "**Directa:** Llamada en la cual llamas a un usuario o un usuario te llama a ti, ganas 120 puntos por cada minuto que dure la llamada." },
        { tipo: "subtitulo", texto: "Transmisión en vivo:" },
        { tipo: "parrafo", texto: "Es un live donde podrás interactuar con varios usuarios y generarás ganancias por los regalos que te envíen." },
        { tipo: "subtitulo", texto: "Regalos:" },
        { tipo: "parrafo", texto: "Son como stickers que los usuarios te pueden enviar y sumar a tus ganancias. Van desde 10 puntos hasta 50.000 puntos dependiendo del regalo, y podrás recibirlos en videollamadas, lives y en el chat del aplicativo." },
        { tipo: "subtitulo", texto: "Tareas:" },
        { tipo: "parrafo", texto: "Tendrás tareas diarias y semanales que acumulan créditos de lealtad, los cuales se convierten en puntos para seguir sumando a tus ganancias." }
      ]
    },
    {
      titulo: "Tipos de llamadas",
      descripcion: "Tienes diferentes formas de obtener ganancias:",
      imagenes: [
        monitoriada,
        privada
      ],
      alt: [
        "Imagen de referencia llamada monitoriada en livejoy",
        "Imagen de referencia llamada privada en livejoy"
      ],
      pieImage: [
        { tipo: "parrafo", texto: "**Monitoreada:** El nombre del usuario arriba a la izquierda esta encerrado con un marco rojo y tiene un ojito de icono." },
        { tipo: "parrafo", texto: "**Privada:**  El marco cambia a color verde y el icono a un candado." }
      ],
      contenidoTipo: "textoEstructurado",
      contenido: [
        { tipo: "subtitulo", texto: "Aleatoria" },
        { tipo: "parrafo", texto: "Video llamada que inicia siendo monitoreada en los primeros 30 segundos, luego de pasar estos 30 segundos en la llamada se vuelve privada." },
        { tipo: "parrafo", texto: "Ganas 5 puntos luego de pasar los primero 20 segundos y al llegar a 30 segundos ganas otros 60 puntos, desde este momento sigues ganando 60 puntos cada minuto que estés en la llamada, es decir:" },
        {
          tipo: "tabla",
          cabeceras: ["Tiempo", "Puntos Ganados", "Total"],
          filas: [
            ["00:20", "+5 puntos", "5 puntos"],
            ["00:30", "+60 puntos", "65 puntos"],
            ["01:30", "+60 puntos", "125 puntos"],
            ["02:30", "+60 puntos", "185 puntos"],
            ["03:30", "+60 puntos", "245 puntos"],
            ["04:30", "+60 puntos", "305 puntos"],
            ["05:30", "+60 puntos", "365 puntos"]
          ]
        },
        { tipo: "subtitulo", texto: "Directa" },
        { tipo: "parrafo", texto: "Video llamada en la cual ganas 40 puntos al iniciarla, ya sea que le contestes a un usuario que te esta llamando directamente o tu llames a un usuario directamente y este te conteste, es una llamada privada todo el tiempo, ganas 120 puntos por cada minuto que dure la video llamada." },
        {
          tipo: "tabla",
          cabeceras: ["Tiempo", "Puntos Ganados", "Total"],
          filas: [
            ["00:00", "+40 puntos", "40 puntos"],
            ["01:00", "+120 puntos", "160 puntos"],
            ["02:00", "+120 puntos", "280 puntos"],
            ["03:30", "+120 puntos", "400  puntos"],
            ["04:30", "+120 puntos", "520 puntos"],
            ["05:30", "+120 puntos", "640 puntos"]
          ]
        }
      ]
    },
    {
      titulo: "Transmisiones",
      imagenes: [
        lives
      ],
      alt: [
        "Referencia como se ve un lives en livejoy"
      ],

      contenidoTipo: "listextoEstructuradota",
      contenido: [
        { tipo: "parrafo", texto: "Un **lives** es una transmisión en vivo monitoreada todo el tiempo donde podrás interactuar con diferentes tipos de usuarios al tiempo y hacer crecer tu perfil atrayendo mas y nuevos usuarios los cuales podrán luego hacerte llamadas o enviar regalos." },
        { tipo: "parrafo", texto: "La forma de obtener ganancias en los lives son mediante los regalos que te envíen los usuarios durante la transmisión, recuerda saludar a todos los usuarios que se conecten para que ellos se sientan cómodos y decidan enviar regalos, también agradecer cada que te envíen un regalo para que luego deseen enviar mas." },
        { tipo: "parrafo", texto: "Puedes invitarlos a que te llamen y así entrar a una llamada directa que te dará mas puntos tanto por cada minuto que dures en esta llamada como los regalos que el usuario desee enviarte." }
      ]
    },
    {
      titulo: "Regalos",
      descripcion:"Los regalos son como stikers que te pueden enviar los usuarios ya sea por videollamadas, lives o chats dentro del mismo aplicativo los cuales suman puntos a tus ganancias dependiendo cual te envíen, cada uno tiene un valor diferente, a continuación veras la lista de regalos con su respectivas ganancias que obtendrías al recibirlo:",
      imagenes: [
        regalos1,
        regalos2,
        regalos3,
        regalos4
      ],
      alt:[
        "Lista regalos y sus valores de Livejoy",
        "Lista regalos y sus valores de Livejoy",
        "Lista regalos y sus valores de Livejoy",
        "Lista regalos y sus valores de Livejoy"
      ],
      contenido: [        
      ]
    },
    {
      titulo: "Tareas",
      imagenes: [
        tareas
      ],
      alt: [
        "Imagen referencia de tareas en livejoy"
      ],
      contenido: [
        { tipo: "parrafo", texto: "Obtendrás tareas tanto diarias como semanales las cuales se irán sumando en créditos de lealtad a medida que las vayas completando, cada tarea te dice cuantos creditos de lealtad ganas al completarla y cual es su equivalente en puntos." },
        { tipo: "parrafo", texto: "Los créditos de lealtad se redimen en puntos al momento del pago teniendo en cuenta que debes tener mas de 1millon de créditos." },
        { tipo: "parrafo", texto: "Cada 100 créditos son 1 punto, en caso que tengas menos créditos al momento del pago estos seguirán acumulados hasta el siguiente pago que superes esta meta, no los perderás." },
        { tipo: "parrafo", texto: "Recuerda reclamar tus créditos siempre cada que termines una tarea para que estos se sumen a los que tienes acumulados y pueda puedan ser redimidos al momento de tu pago." }
      ]
    },
    {
      titulo: "Ganancias",
      contenido: [
        { tipo: "parrafo", texto: "En la app tus ganancias se ven reflejadas en puntos pero al momento de obtener el pago serán en dólares y te explico como es la conversión de estos puntos a los dólares que vas a recibir en el pago; debes tener en cuenta:"},
        { tipo: "item", texto: "Cada mil puntos son 1.3 USD (dólares)"},
        { tipo: "item", texto: "La meta mínima en la app: 20.000 puntos (26 dólares) no hay limite maximo"},
        { tipo: "item", texto: "Fecha de corte lunes 5am (hora colombiana o UTC-5)"},
        { tipo: "subtitulo", texto: "Conversión de Puntos a USD"},
        { tipo: "parrafo", texto: "Fórmula: USD = Puntos / 1000 * 1.3"}
      ]
    },
    {
      titulo: "Reglas importantes",
      contenidoTipo: "lista",
      contenido: [
        { tipo: "parrafo", texto: "Las reglas son importantes para poder mantener un buen comportamiento en el aplicativo y obtener sanciones por desconocerlas que además estas también están para proteger tu identidad, las principales son:"},
        { tipo: "item", texto: "Siempre debe aparecer en cámara únicamente la persona a la cual se le activo el perfil, no pues aparecer nadie mas."},
        { tipo: "item", texto: "Datos personales esta prohibido enviar a un usuario, ni un dato falso porque el aplicativo no es capaz de diferenciar un dato real o falso, estos son números, cuentas bancarias, redes sociales, etc."},
        { tipo: "item", texto: "Prohibido estrictamente temas sobre menores de edad, tampoco pueden escucharse de fondo la voz de alguno."},
        { tipo: "item", texto: "No pedir dinero ni invitar a los usuarios a unirse a otra plataforma con el mismo fin."},
        { tipo: "item", texto: "No se permite uso de sustancias alucinógenas ni mostrar o promover algún tipo de violencia."},
        { tipo: "subtitulo", texto: "Reglas en llamadas monitoreadas"},
        { tipo: "item", texto: "No quitar la cara de la cámara o taparla para que no se vea."},
        { tipo: "item", texto: "Prohibido sacar la lengua, lamerse los labios, pasarse los dedos por los labios o lanzar un beso."},
        { tipo: "item", texto: "No puedes estar en blusa de tiras o muy escotadas, siempre debes estar con algo que te cubra los hombros."},
        { tipo: "item", texto: "No estar pendiente de otro dispositivo."},
        { tipo: "subtitulo", texto: "Reglas en llamadas privadas"},
        { tipo: "parrafo", texto: "Aunque la llamada privada tienes mas libertad siempre debes cumplir las reglas principales la cuales están escritas en el primer en la primer sección."},
        { tipo: "parrafo", texto: "Incumplir algunas de estas 5 reglas llevan a la eliminacion del perfil"},
        { tipo: "subtitulo", texto: "Reglas en lives"},
        { tipo: "parrafo", texto: "Los lives son monitoreados todo el tiempo entonces debemos mantener las mismas reglas de una llamada monitoreada, estar siempre visible ante la cámara y no puede aparecer otra persona."}
      ]
    },
    {
      titulo: "Penalización",
      contenidoTipo: "lista",
      contenido: [
        { tipo: "parrafo", texto: "LEl incumplimiento de las reglas puede causarte penalizaciones a tus ganancias haciendo deducción en tu puntaje el cual puede ser mas descuento si tienes varias advertencias:"},
        { tipo: "item", texto: "La primer advertencia tendrás un descuento de 2.000 puntos, los cuales podrás recuperar solo una única vez si cumples con 2 requisitos luego de incumplirla (sumar 10.000 puntos y tener 7 días sin incumplir las reglas)"},
        { tipo: "item", texto: "Segunda advertencia consecutiva: deducción de 5.000 puntos sin derecho a recuperarlos."},
        { tipo: "item", texto: "Tercer advertencia consecutiva: deducción de 10.000 puntos sin derecho a recuperarlos."},
        { tipo: "item", texto: "Cuarta advertencia consecutiva: desactivación del perfil sin derecho a pago."},
        { tipo: "parrafo", texto: "Tener en cuenta que cada advertencia se puede ir retirando al cumplir las 2 condiciones (sumar 10.000 puntos y tener 7 días sin incumplir las reglas)."},
        { tipo: "parrafo", texto: "Si la falta es grave como es incumplir alguna de las reglas principales la cuenta será suspendida sin derecho a pago."},
        ]
    }
  ]
};

export default Livejoy;
